export default __webpack_public_path__ + "static/media/oggi2.6a71a1d5.jpg";